import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-update-search-table',
  templateUrl: './confirm-update-search-table.component.html',
  styleUrls: []
})
export class ConfirmUpdateSearchTableComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<boolean>) { }

  ngOnInit(): void {
  }

  onYesClick(): void {
    this.dialogRef.close(true);
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
